module.exports = __webpack_public_path__ + "img/earth-takes-over.190146c2.jpg";